import React from 'react';
import { connect } from 'react-redux';

import { MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { CompositeSessionInfoSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { NavLocationSelectors } from '~src/spacesPlatform/selectors/NavigationStateSelectors';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { NavLocationAreas } from '../layout/NavLocation';
import { Breadcrumbs } from './Breadcrumbs';

const mapStateToProps: MapStateToProps<Breadcrumbs.StateProps, Breadcrumbs.Props> = (state: AppState) => ({
  items: state.breadcrumbs,
  linkLastItem: !CompositeSessionInfoSelectors.currentUserIsSiteOrServerAdminSelector(state) && NavLocationSelectors.selectNavLocation(state) === NavLocationAreas.SiteAdmin.site_users,
});

export const ConnectedBreadcrumbs: React.ComponentClass<Breadcrumbs.OwnProps> =
  connect(mapStateToProps, null)(Breadcrumbs);
